<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card" v-if="subscriptionList && subscriptionList.length > 0">
            <div class="card-header">
                <h4 class="card-title mdi mdi-seal"> Subscription Plans</h4>
                <h6 class="card-subtitle"></h6>
            </div>
            <div class="card-body collapse show">
                <div class="table-responsive">
                    <table class="table no-wrap v-middle">
                        <thead>
                        <tr class="border-0">
                            <th class="border-0">Plan Name</th>
                            <th class="border-0">Created At</th>
                            <th class="border-0">Ended At</th>
                            <th class="border-0">Quantity</th>
                            <th class="border-0">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(subscription, index) in subscriptionList">
                            <td>{{subscription.plan_name}}</td>
                            <td>{{subscription.created_at | shorttimestamp}}</td>
                            <td>{{subscription.ended_at | shorttimestamp}}</td>
                            <td>{{subscription.quantity}}</td>
                            <td class="text-capitalize">{{subscription.status}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div class="card-header">
                <h4 class="card-title text-muted">You are not subscribed to any plan.</h4>
                <p>Please select a plan below.</p>
            </div>
        </div>

        <div class="card">
            <plans v-bind:activePlanId="activePlanId" v-bind:activeQuantity="activeQuantity" v-bind:activeSubscriptionId="activeSubscriptionId"></plans>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Plans from './Plans';
    import _ from 'lodash';

    export default {
        name: "Subscription",
        components: {Plans},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                subscriptionList: [],
                activePlanId: '',
                activeQuantity: '',
                activeSubscriptionId: '',
            };

        },
        mounted() {
            this.getSubscriptions();
        },
        methods: {
            async getSubscriptions() {
                console.log(this.currentOrg);
                $(".preloader").fadeIn();
                let reply             = await this.$http.get(`/org/${this.currentOrg.id}/subscriptions`);
                $(".preloader").fadeOut();
                this.subscriptionList = reply.data;
                let activePlan        = _.find(this.subscriptionList, {status: 'active'});
                if(activePlan) {
                    this.activePlanId         = activePlan.plan_id;
                    this.activeQuantity       = activePlan.quantity;
                    this.activeSubscriptionId = activePlan.stripe_subscription_id;
                } else {
                    this.activePlanId         = '';
                    this.activeQuantity       = '';
                    this.activeSubscriptionId = '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
